import { STORAGE_AUTHOR_HASH } from "../constants/localstorage";
import { getStorage } from "../libs/storage";
import { ChatUpdateStatusResponse } from "../proto/ChatUpdateStatus_pb";
import { RoomMessageStatus } from "../proto/Global_pb";
import { GroupUpdateStatusResponse } from "../proto/GroupUpdateStatus_pb";
import store from "../store";
import { editRoomMessage, markAsReadMessages } from "../store/messages/actions";
import { editRoom, updateLastMessageStatus } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomUpdateStatusResponse extends BaseHandler<ChatUpdateStatusResponse | GroupUpdateStatusResponse> {
  handle() {
    const roomUpdateStatusResponse = this.response.toObject();
    if (roomUpdateStatusResponse.status === RoomMessageStatus.SEEN) {
      store.dispatch(
        markAsReadMessages({
          roomId: roomUpdateStatusResponse.roomId,
          messageId: roomUpdateStatusResponse.messageId,
          updaterAuthorHash: roomUpdateStatusResponse.updaterAuthorHash,
        })
      );

      if (roomUpdateStatusResponse.updaterAuthorHash === getStorage(STORAGE_AUTHOR_HASH)) {
        store.dispatch(
          editRoom({
            roomId: roomUpdateStatusResponse.roomId,
            room: {
              unreadCount: 0,
            },
          })
        );
      }
    } else {
      store.dispatch(
        editRoomMessage({
          messageId: roomUpdateStatusResponse.messageId,
          message: {
            status: roomUpdateStatusResponse.status,
            statusVersion: roomUpdateStatusResponse.statusVersion,
          },
        })
      );
    }
    store.dispatch(updateLastMessageStatus({ roomId: roomUpdateStatusResponse.roomId, status: roomUpdateStatusResponse.status }));
  }
}
